import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { Geolocation } from "@capacitor/geolocation";

@Component({
  selector: "sm-business-create",
  templateUrl: "./business-create.component.html",
  styleUrls: ["./business-create.component.scss"],
})
export class BusinessCreateComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);
  @ViewChild("mapContainer", { static: false }) mapContainer!: ElementRef;
  @ViewChild("autocomplete", { static: false }) autocomplete!: ElementRef;
  map!: google.maps.Map;
  marker!: google.maps.Marker;
  geocoder!: google.maps.Geocoder;
  loader: boolean = false;
  showStep1: boolean = true;
  showStep2: boolean = false;
  showStep3: boolean = false;
  showStep4: boolean = false;
  panelOpenState = false;
  panelState: any = [true, false, false, false, false];
  panelState2: any = [true, false, false, false, false];
  panelState3: any = [true, false, false, false, false];
  panelState4: any = [true, false, false, false, false];
  public newBusinessObj: any = {
    name: null,
    phone: null,
    entityType: null,
    entityDesc: null,
    referenceNo: null,
    ownerName: null,
    ownerPhone: null,
    entityStatus: 1,
    isMediaOnly: 0,
    addressInfo: {
      addressLine: null,
    },
  };
  selectedBusinessType: number = 0;
  allServiceTemplateData: any = [];

  businessTypeData: any = [
    {
      title: "Business or Shop",
      isSelected: 1,
      assetUrl:
        "../../../../assets/images/business-creation-imgs/business_type.png",
    },
    {
      title: "Individual professional",
      isSelected: 0,
      assetUrl:
        "../../../../assets/images/business-creation-imgs/individual_type.png",
    },
  ];
  serviceTypeData: any = [
    {
      title: "Shop/In-premise",
      isSelected: 0,
      assetUrl:
        "../../../../assets/images/business-creation-imgs/shop_type.png",
    },
    {
      title: "Home service",
      isSelected: 0,
      assetUrl:
        "../../../../assets/images/business-creation-imgs/home_type.png",
    },
    {
      title: "Virtual",
      isSelected: 0,
      assetUrl:
        "../../../../assets/images/business-creation-imgs/virtual_type.png",
    },
  ];
  professsionalGender: any = [
    {
      title: "Male professional",
      name: "male",
      isSelected: 0,
      assetUrl: "../../../../assets/images/business-creation-imgs/male.png",
    },
    {
      title: "Female professional",
      name: "female",
      isSelected: 0,
      assetUrl: "../../../../assets/images/business-creation-imgs/female.png",
    },
    {
      title: "Others",
      name: "others",
      isSelected: 0,
      assetUrl: "../../../../assets/images/business-creation-imgs/unisex.png",
    },
  ];
  serviceTypeGender: any = [
    {
      id: 1,
      title: "Ladies",
      isSelected: 0,
      assetUrl: "../../../../assets/images/business-creation-imgs/female.png",
    },
    {
      id: 2,
      title: "Gents",
      isSelected: 0,
      assetUrl: "../../../../assets/images/business-creation-imgs/male.png",
    },
    {
      id: 3,
      title: "Unisex",
      isSelected: 0,
      assetUrl: "../../../../assets/images/business-creation-imgs/unisex.png",
    },
  ];
  _apisub: Subscription;
  selectedPlan: any;
  constructor(
    private _navService: NavigationService,
    private loaderservice: LoaderServiceService,
    private _apiService: ApiService,
    private router: Router
  ) {
    this._navService.hideSidebarAndNav = false;

    this._apisub = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.UPDATE_ENTITY_INFO_RESULT) {
        if (resData.result) {
          localStorage.setItem(
            "newlyCreatedBusinessHash",
            resData.result.hash_id
          );
          this.selectedPlan =
            typeof sessionStorage.getItem(
              SM_CONSTANTS.SELECTED_PURCHASED_PLAN
            ) == "string"
              ? JSON.parse(
                  sessionStorage.getItem(SM_CONSTANTS.SELECTED_PURCHASED_PLAN)!
                )
              : sessionStorage.getItem(SM_CONSTANTS.SELECTED_PURCHASED_PLAN);
          let data = {
            subscriptionInfo: {
              fromDate: this.formatDateString(new Date()),
              toDate: this.addDaysToDate(
                new Date(),
                typeof this.selectedPlan.validity == "string"
                  ? +this.selectedPlan.validity.split(" ")[0]
                  : this.selectedPlan.validity
              ),
              oldEntitySubscriptionActHash: "",
              subscriptionStatus: "",
            },
          };

          this._apiService.updateEntitySubsciptionInfo(
            resData.result.hash_id,
            this.selectedPlan.hash_id,
            data
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SUBSCRIPTION_INFO
      ) {
        if (resData.result) {
          //  this.paymentResponse = null
          this.loaderservice.showLoader = false;
          this._apiService.getBasicEntityList();
          this.router.navigate(["/businesses/details"], {
            queryParams: {
              entityHash: localStorage.getItem("newlyCreatedBusinessHash"),
            },
          });
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_SERVICE_TEMPLATES
      ) {
        this.allServiceTemplateData = [];
        if (resData.result) {
          this.allServiceTemplateData = resData.result;
          this.allServiceTemplateData.forEach((element: any) => {
            element.isSelected = 0;
          });
          this.businessTypeData[0].isSelected = 1;
          this.toShowServiceTemplates = this.allServiceTemplateData.filter(
            (item: any) => item.entity_type == 1
          );
          this.loaderservice.showLoader = false;
          this.loader = false;
        }
      }
    });
  }

  toShowServiceTemplates: any = [];
  ngOnInit(): void {
    if (
      sessionStorage.getItem(SM_CONSTANTS.SELECTED_PURCHASED_PLAN) &&
      sessionStorage.getItem(SM_CONSTANTS.SELECTED_PURCHASED_PLAN) != "null"
    ) {
      this.loader = true;
      this.loaderservice.showLoader = true;
      this._apiService.getEntityServiceTemplates();
    } else {
      this.router.navigate(["/dashboard"]);
    }
    // this.loader = true
    // this.loaderservice.showLoader = true
    // this._apiService.getEntityServiceTemplates()
  }

  checkServicesSelected() {
    const index = this.toShowServiceTemplates.findIndex(
      (item: any) => item.isSelected == true || item.isSelected == 1
    );

    if (index != -1) {
      return false;
    } else {
      return true;
    }
  }
  isGenderSelected() {
    if (this.businessTypeData[1].isSelected == 1) {
      const index = this.professsionalGender.findIndex(
        (item: any) => item.isSelected == 1
      );
      if (index != -1) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  checkServiceTypeSelected() {
    const index = this.serviceTypeData.findIndex(
      (item: any) => item.isSelected == true || item.isSelected == 1
    );

    if (index != -1) {
      return false;
    } else {
      return true;
    }
  }
  checkServiceTargetTypeSelected() {
    const index = this.serviceTypeGender.findIndex(
      (item: any) => item.isSelected == 1
    );

    if (index != -1) {
      return false;
    } else {
      return true;
    }
  }

  checkForm() {
    if (this.businessTypeData[1].isSelected == 1) {
      if (
        !this.newBusinessObj.name ||
        !this.newBusinessObj.phone ||
        this.newBusinessObj.phone.length < 3 ||
        !this.newBusinessObj.entityDesc
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        !this.newBusinessObj.name ||
        !this.newBusinessObj.phone ||
        this.newBusinessObj.phone.length < 3 ||
        !this.newBusinessObj.entityDesc ||
        !this.newBusinessObj.ownerName ||
        !this.newBusinessObj.ownerPhone
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  checkDisabilityForCheckBox(item: any) {
    //if regular service
    if (item.revenue_mode == 1) {
      const index = this.toShowServiceTemplates.findIndex(
        (item: any) => item.revenue_mode == 2 && item.isSelected
      );
      // if a subscription service is checked
      if (index != -1) {
        return true;
      }
      return false;
    }
    // if subscription service
    else if (item.revenue_mode == 2) {
      const index = this.toShowServiceTemplates.findIndex(
        (item: any) => item.revenue_mode == 1 && item.isSelected
      );
      // if a regular service is checked
      if (index != -1) {
        return true;
      }
      return false;
    }
    return false;
  }

  ngAfterViewInit(): void {
    // if (this.showStep4) {
    // this.initializeMap();
    // }
  }
  changeBusinessType(index: any) {
    this.allServiceTemplateData.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.businessTypeData.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.professsionalGender.forEach((element: any) => {
      element.isSelected = 0;
    });

    this.businessTypeData[index].isSelected = 1;
    if (index == 0) {
      this.toShowServiceTemplates = this.allServiceTemplateData.filter(
        (item: any) => item.entity_type == 1
      );
    } else {
      this.toShowServiceTemplates = this.allServiceTemplateData.filter(
        (item: any) => item.entity_type == 2
      );
    }
    console.log(this.professsionalGender);
  }
  selectServiceType(index: any) {
    if (!this.checkDisabilityForCheckBox(this.toShowServiceTemplates[index])) {
      this.toShowServiceTemplates[index].isSelected =
        !this.toShowServiceTemplates[index].isSelected;
    }
  }
  selectServiceTypeData(index: any) {
    console.log(this.serviceTypeData[index]);
    console.log(this.serviceTypeData[index].isSelected);

    this.serviceTypeData[index].isSelected =
      !this.serviceTypeData[index].isSelected;
  }

  serviceTargetType: any;
  selectServiceTypeGender(index: any) {
    this.serviceTypeGender.forEach((element: any) => {
      element.isSelected = 0;
    });

    this.serviceTypeGender[index].isSelected = 1;
    this.serviceTargetType = this.serviceTypeGender[index].id;
  }

  providerGender: any;
  selectProfessionalGender(index: any) {
    this.professsionalGender.forEach((element: any) => {
      element.isSelected = 0;
    });

    this.professsionalGender[index].isSelected = 1;
    this.providerGender = this.professsionalGender[index].name;
  }

  onClickNext(step: any) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (step == 1) {
      this.showStep1 = false;
      this.showStep2 = true;
    } else if (step == 2) {
      if (this.businessTypeData[1].isSelected) {
        this.newBusinessObj.ownerName = localStorage.getItem(
          SM_CONSTANTS.OWNER_NAME
        );
        this.newBusinessObj.ownerPhone = localStorage
          .getItem(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER)
          ?.slice(3);
      }
      this.showStep2 = false;
      this.showStep3 = true;
    } else if (step == 3) {
      this.showStep3 = false;
      this.showStep4 = true;

      this.getCurrentLocation()
        .then((address) => {
          console.log("address for business::::>>>>>", JSON.stringify(address));
          setTimeout(() => {
            this.initializeMap(address);
          }, 1);
        })
        .catch((error) => {
          console.error("Error getting location:", error);

          // // Optional: better error feedback
          // if (error.code === 1) {
          //   alert("Location permission denied. Showing default location.");
          // } else if (error.code === 2) {
          //   alert("Location unavailable. Showing default location.");
          // } else if (error.code === 3) {
          //   alert("Location request timed out. Showing default location.");
          // } else {
          //   alert(
          //     "Unable to retrieve your location. Showing default location."
          //   );
          // }

          setTimeout(() => {
            this.initializeMap({
              latitude: "28.6139298",
              longitude: "77.2088282",
            });
          }, 1);
        });
    }
  }

  onClickBack(step: any) {
    if (step == 2) {
      this.showStep2 = false;
      this.showStep1 = true;
    } else if (step == 3) {
      this.showStep3 = false;
      this.showStep2 = true;
    } else if (step == 4) {
      this.showStep4 = false;
      this.showStep3 = true;
    }
  }
  cancel() {
    this.router.navigate(["/purchased-plan"]);
  }
  onSubmit() {
    console.log(this.toShowServiceTemplates);
    let r_mode = this.toShowServiceTemplates.filter(
      (item: any) => item.isSelected == 1 || item.isSelected
    );
    let bodydata = {
      entityInfo: {
        name: this.newBusinessObj.name,
        phone: this.newBusinessObj.phone,
        entityCountryCode: this.entityCountryCode.dial_code,
        email: this.newBusinessObj.email,
        business_website_address: this.newBusinessObj.business_website_address,
        entityDesc: this.newBusinessObj.entityDesc,
        referenceNo: this.newBusinessObj.referenceNo
          ? this.newBusinessObj.referenceNo
          : null,
        ownerName: this.newBusinessObj.ownerName
          ? this.newBusinessObj.ownerName
          : null,
        ownerPhone: this.newBusinessObj.ownerPhone
          ? this.newBusinessObj.ownerPhone
          : null,
        ownerCountryCode: this.ownerCountryCode.dial_code,
        entityStatus: "1",
        isMediaOnly: 0,
        operationMode: 2,
        entityType: this.businessTypeData[0].isSelected == 1 ? 1 : 2,
        shopServiceStatus:
          this.serviceTypeData[0].isSelected ||
          this.serviceTypeData[0].isSelected == 1
            ? 0
            : 2,
        homeServiceStatus:
          this.serviceTypeData[1].isSelected ||
          this.serviceTypeData[1].isSelected == 1
            ? 0
            : 2,
        virtual_service_status:
          this.serviceTypeData[2].isSelected ||
          this.serviceTypeData[2].isSelected == 1
            ? 0
            : 2,
        serviceTargetType: this.serviceTargetType,
        providerGender: this.providerGender ?? null,
        services: this.toShowServiceTemplates
          .filter((item: any) => item.isSelected == 1 || item.isSelected)
          .map((item: any) => item.hash_id),
        addressInfo: {
          addressLine: this.formattedAddress,
          city:
            this.selectedLocation.city && this.selectedLocation.city != "null"
              ? this.selectedLocation.city
              : "null",
          state:
            this.selectedLocation.state && this.selectedLocation.state != "null"
              ? this.selectedLocation.state
              : "null",
          country:
            this.selectedLocation.country &&
            this.selectedLocation.country != "null"
              ? this.selectedLocation.country
              : "null",
          zip:
            this.selectedLocation.zip && this.selectedLocation.zip != "null"
              ? this.selectedLocation.zip
              : "null",
          lat: this.lat && this.lat != "null" ? this.lat : "null",
          lng: this.lng && this.lng != "null" ? this.lng : "null",
        },
        currency: this.countryInfo ? this.countryInfo.currency : "INR",
        currencySymbol: this.countryInfo
          ? this.countryInfo.currencySymbol
          : "₹",
        revenue_mode: r_mode[0].revenue_mode,
      },
    };

    console.log(bodydata);

    this.loaderservice.showLoader = true;
    this._apiService.updateEntityInfo(bodydata);
  }

  // -------------------- MAP THINGS ---------------------------
  lat: any;
  lng: any;
  initializeMap(address: any) {
    this.lat = address.latitude;
    this.lng = address.longitude;
    const mapOptions = {
      center: new google.maps.LatLng(address.latitude, address.longitude),
      zoom: 12,
    };

    this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);

    this.marker = new google.maps.Marker({
      map: this.map,
      draggable: true,
    });

    this.marker.setPosition(mapOptions.center);
    this.geocoder = new google.maps.Geocoder();
    const latLng = new google.maps.LatLng(address.latitude, address.longitude);
    this.geocodePosition(latLng);

    google.maps.event.addListener(this.marker, "dragend", (event) => {
      this.geocodePosition(event.latLng);
    });

    const autocomplete = new google.maps.places.Autocomplete(
      this.autocomplete.nativeElement
    );
    autocomplete.bindTo("bounds", this.map);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      console.log(place);

      if (!place.geometry) {
        console.log("Autocomplete's returned place contains no geometry");
        return;
      }

      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport);
      } else {
        this.map.setCenter(place.geometry.location);
        this.map.setZoom(17);
      }

      this.marker.setPosition(place.geometry.location);
      this.storeLocation(place.address_components, place.formatted_address);
      const location = place.geometry.location;
      this.lat = location.lat().toFixed(6);
      this.lng = location.lng().toFixed(6);
    });
  }
  // this.storeLocation( results[ 0 ].address_components, results[ 0 ].formatted_address );
  geocodePosition(latLng: google.maps.LatLng) {
    console.log(latLng);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          console.log(results[0]);
          this.autocomplete.nativeElement.value = results[0].formatted_address;
          console.log("Address:", results[0].formatted_address);
          this.storeLocation(
            results[0].address_components,
            results[0].formatted_address
          );
          const location = results[0].geometry.location;
          this.lat = location.lat().toFixed(6);
          this.lng = location.lng().toFixed(6);
        } else {
          console.log("No results found");
        }
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  }

  // async getCurrentLocation(): Promise<any> {
  //   return new Promise(async (resolve, reject) => {
  //     if ('geolocation' in navigator) {
  //       navigator.geolocation.getCurrentPosition(
  //         async position => {
  //           const { latitude, longitude } = position.coords;
  //           try {
  //             resolve({ latitude, longitude});
  //           } catch (error) {
  //             reject('Error getting location info');
  //           }
  //         },
  //         error => reject(error)
  //       );
  //     } else {
  //       reject('Geolocation is not supported by your browser.');
  //     }
  //   });
  // }

  async getCurrentLocation(): Promise<any> {
    try {
      const position = await Geolocation.getCurrentPosition();
      const coords = position.coords;
      console.log(JSON.stringify(position));

      return {
        latitude: coords.latitude.toString(),
        longitude: coords.longitude.toString(),
      };
    } catch (err) {
      console.error("Error fetching location", err);
      throw err;
    }
  }

  selectedLocation: any = {};
  formattedAddress: any;
  storeLocation(location: any, formatted_address: any) {
    const selectedLocation: any = {};
    location.forEach((element: any) => {
      if (element.types.includes("postal_code")) {
        selectedLocation.zip = element.long_name;
      } else if (element.types.includes("country")) {
        selectedLocation.country = element.long_name;
      } else if (element.types.includes("administrative_area_level_1")) {
        selectedLocation.state = element.long_name;
      } else if (element.types.includes("locality")) {
        selectedLocation.city = element.long_name;
      } else if (element.types.includes("route")) {
        selectedLocation.address = element.long_name;
      }
    });
    this.formattedAddress = formatted_address;
    this.selectedLocation = selectedLocation;
  }

  // --------------- MISC FUNCTIONS ----------------
  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  addDaysToDate(currentDate: Date, daysToAdd: number): string {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + daysToAdd);

    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91"
  );
  entityCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code === this.countryInfo.countryCode &&
      country.code === this.countryInfo.code
  );
  ownerCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code ===
      localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE)
  );
  searchString: UntypedFormControl = new UntypedFormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  ngOnDestroy(): void {
    this._apisub.unsubscribe();
  }
}
